const ProfileTypes = {
  Individual: 'me',
  Organization: 'org',
};

const TargetViewers = {
  All: 'all',
  SelectedOrg: 'selected-org',
  MyOrg: 'my-org',
};

module.exports = {
  ProfileTypes,
  TargetViewers,
};
